import React from "react";
import { Layout } from "src/components/layout/Layout";
import { ModuleRouter } from "src/components/molecules";
import { ConfigurationRoute } from "./configuration.routes";

export function Configuration() {
  return (
    <Layout>
      {ConfigurationRoute.subRoutes && (
        <ModuleRouter subRoutes={ConfigurationRoute.subRoutes} path={ConfigurationRoute.path} />
      )}
    </Layout>
  );
}
